import { API_VERSION, HOME_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_COMMUNITY_VENDORS = `${HOME_SERVICE}/community-vendors`;

export const communityVendors = {
  getAll: async ({ filters, sort, params, signal, top, skip } = {}) => {
    const options = await apiOptions({
      url: API_COMMUNITY_VENDORS,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
      top,
      skip,
    });
    return apiRequest(options);
  },
  getById: async ({ id, toastMessageConfig } = {}) => {
    const options = await apiOptions({
      url: `${API_COMMUNITY_VENDORS}/${id}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options, toastMessageConfig);
  },
  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: API_COMMUNITY_VENDORS,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_COMMUNITY_VENDORS}/${id}`,
      method: "delete",
      data: data,
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options, toastMessageConfig);
  },
};
